import api from "./api";

/**
 * Cliente de frontend dos recursos WABA (ondas 1-3). Fino — só chama os
 * endpoints /waba/:whatsappId/*. Use junto de isFeatureOn(WABA_FLAGS.X) do
 * helpers/featureFlags para só mostrar a UI quando a flag estiver ligada.
 *
 * whatsappId = id da conexão WABA OFICIAL. O backend recusa (400) conexão não
 * oficial e (403) quando a flag está OFF.
 */

export const sendCtaUrl = (whatsappId, payload) =>
  api.post(`/waba/${whatsappId}/cta-url`, payload);

export const sendTyping = (whatsappId, messageId) =>
  api.post(`/waba/${whatsappId}/typing`, { messageId });

export const getBusinessProfile = whatsappId =>
  api.get(`/waba/${whatsappId}/profile`);

export const updateBusinessProfile = (whatsappId, fields) =>
  api.put(`/waba/${whatsappId}/profile`, fields);

export const getConversationalAutomation = whatsappId =>
  api.get(`/waba/${whatsappId}/conversational-automation`);

export const setConversationalAutomation = (whatsappId, payload) =>
  api.post(`/waba/${whatsappId}/conversational-automation`, payload);

export const blockUsers = (whatsappId, numbers) =>
  api.post(`/waba/${whatsappId}/block`, { numbers });

export const unblockUsers = (whatsappId, numbers) =>
  api.post(`/waba/${whatsappId}/unblock`, { numbers });

export const getConversationAnalytics = (whatsappId, params) =>
  api.get(`/waba/${whatsappId}/analytics`, { params });

export const sendFlow = (whatsappId, payload) =>
  api.post(`/waba/${whatsappId}/flow`, payload);

export const listFlows = whatsappId => api.get(`/waba/${whatsappId}/flows`);

export const sendFlowByTicket = (whatsappId, payload) =>
  api.post(`/waba/${whatsappId}/flow-send`, payload);

export const listCatalogProducts = whatsappId =>
  api.get(`/waba/${whatsappId}/catalog-products`);

export const createProduct = (whatsappId, payload) =>
  api.post(`/waba/${whatsappId}/catalog-products`, payload);

export const updateProduct = (whatsappId, productId, payload) =>
  api.put(`/waba/${whatsappId}/catalog-products/${productId}`, payload);

export const deleteProduct = (whatsappId, productId) =>
  api.delete(`/waba/${whatsappId}/catalog-products/${productId}`);

export const sendSingleProduct = (whatsappId, payload) =>
  api.post(`/waba/${whatsappId}/product`, payload);

export const sendMultiProduct = (whatsappId, payload) =>
  api.post(`/waba/${whatsappId}/products`, payload);

export const sendOrderDetails = (whatsappId, payload) =>
  api.post(`/waba/${whatsappId}/order-details`, payload);
